import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import React from "react";
import { Toaster } from "randmarcomps";
import theme from "./styles/theme";


export default function withRoot<T extends object>(
  Component: React.ComponentType<T>
) {
  const WithRoot = (props: T) => {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Component {...props} />
        <Toaster />
      </ThemeProvider>
    );
  };

  WithRoot.displayName = `withRoot(${Component.displayName || Component.name || "Component"})`;

  return WithRoot;
}
